import { Link } from "react-router-dom";
import { scrollToId } from "../lib/scroll";
import { BUSINESS } from "../constants/business";
import { LogoMark } from "./LogoMark";

export const Footer = () => (
  <footer className="border-t border-zinc-800 bg-[#0A0A0A] px-6 md:px-12 lg:px-24 py-20" data-testid="footer">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <LogoMark className="h-14 w-auto" testId="footer-logo" />
        <p className="mt-4 font-oswald uppercase tracking-wide text-[#FF3B30] text-sm" data-testid="footer-tagline">
          "{BUSINESS.tagline}"
        </p>
      </div>

      <address className="not-italic text-sm text-zinc-400 space-y-2" data-testid="footer-contact-info">
        <p>{BUSINESS.street}</p>
        <p>{BUSINESS.city}</p>
        <p className="pt-2">{BUSINESS.hoursDays}</p>
        <p>{BUSINESS.hoursTime}</p>
        <p className="pt-2">
          <a href={BUSINESS.phoneHref} className="hover:text-[#FF3B30] transition-colors duration-200" data-testid="footer-phone-link">
            {BUSINESS.phone}
          </a>
        </p>
        <p className="pt-2">
          <a href={`mailto:${BUSINESS.email}`} className="hover:text-[#FF3B30] transition-colors duration-200 break-all" data-testid="footer-email-link">
            {BUSINESS.email}
          </a>
        </p>
      </address>

      <nav className="flex flex-col gap-3 text-sm" aria-label="Footer">
        <button onClick={() => scrollToId("services")} className="text-left text-zinc-400 hover:text-[#FF3B30] transition-colors duration-200 uppercase tracking-[0.15em] text-xs" data-testid="footer-link-services">Services</button>
        <button onClick={() => scrollToId("contact")} className="text-left text-zinc-400 hover:text-[#FF3B30] transition-colors duration-200 uppercase tracking-[0.15em] text-xs" data-testid="footer-link-contact">Contact</button>
        <button onClick={() => scrollToId("request")} className="text-left text-zinc-400 hover:text-[#FF3B30] transition-colors duration-200 uppercase tracking-[0.15em] text-xs" data-testid="footer-link-request">Request Service</button>
        <button onClick={() => scrollToId("faq")} className="text-left text-zinc-400 hover:text-[#FF3B30] transition-colors duration-200 uppercase tracking-[0.15em] text-xs" data-testid="footer-link-faq">FAQ</button>
        <Link to="/privacy" className="text-zinc-400 hover:text-[#FF3B30] transition-colors duration-200 uppercase tracking-[0.15em] text-xs" data-testid="footer-link-privacy">Privacy Policy</Link>
        <Link to="/terms" className="text-zinc-400 hover:text-[#FF3B30] transition-colors duration-200 uppercase tracking-[0.15em] text-xs" data-testid="footer-link-terms">Terms &amp; Conditions</Link>
      </nav>
    </div>

    <div className="mt-16 pt-8 border-t border-zinc-800 flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-600">
      <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
      <p>Auto &amp; Diesel Repair · Oklahoma City, OK</p>
    </div>
  </footer>
);
